const styles = {
  heading: {
    color: '#212322',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  wrapper: {
    width: '100%',
    marginTop: '50px',
    borderRadius: '3px',
    boxShadow: '0 0 7px 0 rgba(178,178,178,0.5), 0 2px 2px 0 rgba(0,0,0,0.24)',
    '&& > div': {
      padding: '16px 21px',
    },
    '&& > div[role=panel] > div': {
      padding: '0',
      borderRadius: '0',
      boxShadow: 'none',
    },
    '&& > div[role=panel] div[role=button]': {
      padding: '0',
      minHeight: 'auto',
    },
    '&& > div[role=panel] div[role=button] > div': {
      margin: '0',
    },
    '&& > div[role=panel] div[role=button] div[role=button]': {
      right: 'auto',
      left: '-5px',
      width: 'auto',
      height: 'auto',
    },
    '&& > div[role=panel] div[role=button] p': {
      color: 'rgba(33,35,34,0.5)',
      fontSize: '12px',
      marginLeft: '27px',
    },
    '&& > div:not(:last-child)': {
      borderBottom: '1px solid rgba(178,178,178,0.5)',
    },
  },
  template: {
    position: 'relative',
    marginTop: '40px',
    '&& > span': {
      color: 'rgba(33,35,34,0.5)',
      fontSize: '12px',
    },
    '&& > p': {
      color: '#212322',
      fontSize: '14px',
    },
  },
  container: {
    '&& > div': {
      boxShadow: 'none',
    },
  },
  extendedDetails: {
    padding: '0',
    flexDirection: 'column',
  },
  extendedDetailsDescription: {
    paddingTop: '43px',
    paddingBottom: '20px',
  },
  input: {
    width: '100%',
  },
  textField: {
    width: '100%',
  },
  changeTemplateButton: {
    display: 'inline-block',
    marginLeft: '50px',
    position: 'absolute',
    top: '0',
    right: '0',
  },
  inlineBlock: {
    display: 'inline-block',
  },
};

export default styles;
